import { Routes } from '@app/constants/routes';
import { TypedLink } from '@app/router';
import { Outlet } from 'react-router-dom';

export const RenderModule: React.FC = () => {
  return (
    <div>
      <div className="flex gap-4 p-4">
        <h3>Render module</h3>
        <TypedLink
          to={Routes.index}
          className="mb-4 block rounded bg-zinc-700 p-2 text-center text-white hover:bg-primary"
        >
          Go Home Page
        </TypedLink>
      </div>
      <div className="main-container">
        <Outlet />
      </div>
    </div>
  );
};
